import axios from 'axios'
import Loading from 'muse-ui-loading'

const isProduction = process.env.NODE_ENV === 'production'

const baseURL = isProduction
  ? window.STATIC_CONFIG.host
  : window.STATIC_CONFIG.test
// const baseURL = isProduction
//   ? window.STATIC_CONFIG.host
//   : 'http://dingxiang.yocent.cn:8888/'

// 创建axios实例
const service = axios.create({
  // 测试服务器
  baseURL,
  // 请求超时时间
  timeout: 15000,
  // headers: {
  // },
})

var loading
var loadingCount = (window.loadingCount = 0)

function closeLoading(noLoading) {
  if (noLoading) return
  loadingCount--
  if (loadingCount <= 0 && loading) {
    loading.close()
    loading = null

    // 尽可能的增加容错率
    if (loadingCount < 0) {
      console.error('utils/request.js LoadingCount < 0: ', loadingCount)
      loadingCount = 0
    }
  }
}
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    if (!config.noFullScreenLoading && !loading) {
      loading = Loading()
    }
    if (!config.noFullScreenLoading) {
      loadingCount++
    }
    return config
  },
  (error) => {
    // Do something with request error
    console.error('interceptors::', error) // for debug
    window.vm.$NewToast.error(error, 2000)
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const data = response.data

    closeLoading(response.config.noFullScreenLoading)

    if (data.status !== 1) {
      console.log(
        'service.interceptors.response: ',
        response,
        response.config.url,
        response.config.noToast
      )
      if (!response.config.noToast) {
        window.vm.$NewToast.info(data.error, 1500)
      }

      return Promise.reject(data)
    } else {
      // 文件上传格式不同
      if (response.request.responseURL.indexOf('admin/Upload2/upload') > -1)
        return data
      return data.data
    }
  },
  (error) => {
    console.error('interceptors::', error)
    window.vm.$NewToast.error(error.response.data.error, 2000)
    setTimeout(() => {
      closeLoading()
    }, 800)
    return Promise.reject(error)
  }
)

export default service
